// MARK://dhk8/admin-shell/lib/queries/audit
// Queries tipadas de auditoría — I0 / ADR-0004. El Admin lee el log de auditoría por
// el grafo (subgraph platform-audit, compuesto en el gateway). El tenant lo deriva el
// backend del JWT (no se manda). `payload` viene como String JSON → se parsea en el
// cliente (audit-format.ts).
//   · AdminAuditLog  → historial de UNA entidad (aggregateId = id de la entidad).
//   · AdminAuditFeed → feed global del tenant, con filtros (módulo/evento/severidad/fechas).
import { graphql } from '../../gql/index.js'

export const AdminAuditLogQuery = graphql(`
  query AdminAuditLog($entityId: String!, $eventName: String, $page: Int, $limit: Int) {
    auditLog(entityId: $entityId, eventName: $eventName, page: $page, limit: $limit) {
      items {
        id
        eventName
        aggregateId
        actorType
        actorId
        severity
        timestamp
        payload
      }
      total
      page
      limit
    }
  }
`)

export const AdminAuditFeedQuery = graphql(`
  query AdminAuditFeed($filter: AuditFeedFilter, $page: Int, $limit: Int) {
    auditFeed(filter: $filter, page: $page, limit: $limit) {
      items {
        id
        eventName
        aggregateId
        actorType
        actorId
        severity
        timestamp
        payload
      }
      total
      page
      limit
    }
  }
`)
